import { TrendUpIcon, TrendDownIcon, MinusIcon } from "@phosphor-icons/react";
import { fmtInt, fmtMoney, fmtPct, unitsText } from "./format";

function Delta({ v, suffix, isCount }) {
  if (v === null || v === undefined) return null;
  const cls = v > 0 ? "text-emerald-400" : v < 0 ? "text-red-400" : "text-text-muted";
  const Icon = v > 0 ? TrendUpIcon : v < 0 ? TrendDownIcon : MinusIcon;
  return (
    <div className={`text-[10px] mt-1 flex items-center gap-1 ${cls}`}>
      <Icon size={10} /> {isCount ? `${v > 0 ? "+" : ""}${fmtInt(v)}` : fmtPct(v)} {suffix}
    </div>
  );
}

/** KPIs del reporte (respetan todos los filtros). Costos solo si el backend los envía (Administrador). */
export default function KpiCards({ kpis, periodos }) {
  const hasComp = periodos.length > 1;
  const vs = hasComp ? `vs ${periodos[1]?.label}` : "";
  const mixed = kpis.unidades_mixtas;
  const cards = [
    {
      key: "unidades", label: "Unidades vendidas",
      value: mixed ? unitsText(kpis.unidades_por_unidad) : fmtInt(kpis.unidades),
      small: mixed, delta: hasComp ? kpis.var_unidades_pct : null, suffix: vs,
    },
    { key: "monto", label: "Monto vendido", value: fmtMoney(kpis.monto), delta: hasComp ? kpis.var_monto_pct : null, suffix: vs },
    { key: "clientes", label: "Clientes que compraron", value: fmtInt(kpis.clientes), delta: hasComp ? kpis.clientes_dif : null, isCount: true, suffix: hasComp ? `(${fmtInt(kpis.clientes_ant)} antes)` : "" },
    { key: "facturas", label: "Facturas", value: fmtInt(kpis.facturas), delta: hasComp ? kpis.facturas_dif : null, isCount: true, suffix: vs },
    { key: "productos", label: "Productos distintos", value: fmtInt(kpis.productos) },
  ];
  if (hasComp) cards.push({ key: "crecimiento", label: "Crecimiento", value: fmtPct(kpis.crecimiento_pct), suffix: vs });
  if (kpis.costo !== undefined) {
    cards.push({ key: "costo", label: "Costo total", value: fmtMoney(kpis.costo) });
    cards.push({ key: "utilidad", label: "Utilidad", value: fmtMoney(kpis.utilidad) });
    cards.push({ key: "margen", label: "Margen", value: fmtPct(kpis.margen).replace("+", "") });
  }
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3" data-testid="kpi-cards">
      {cards.map((c) => (
        <div key={c.key} className="bg-card border border-border/60 rounded-lg p-3">
          <div className="text-[10px] uppercase tracking-wider text-text-muted">{c.label}</div>
          <div className={`${c.small ? "text-sm" : "text-xl"} font-heading font-semibold mt-1 text-white`} data-testid={`kpi-${c.key}`}
            title={c.small ? "Unidades de medida distintas: no se suman" : undefined}>{c.value}</div>
          <Delta v={c.delta} suffix={c.suffix} isCount={c.isCount} />
          {c.delta === undefined && c.suffix && <div className="text-[10px] mt-1 text-text-muted">{c.suffix}</div>}
        </div>
      ))}
    </div>
  );
}
